"use client"

import { Loader2, CheckCircle2 } from "lucide-react"
import type { ToolRenderProps } from "@/hooks/useToolRenderer"

const TOOL_LABELS: Record<string, string> = {
  check_halal_status: "Checking halal status",
  read_japanese_label: "Analyzing label",
  scan_food_label_image: "Scanning label photo",
  search_halal_stores: "Searching halal stores",
  search_products: "Searching products",
  generate_halal_recipe: "Creating recipe",
  create_shopping_list: "Building shopping list",
  get_my_preferences: "Loading preferences",
  update_my_preferences: "Saving preferences",
  submit_feedback: "Recording feedback",
}

export function ToolCallDisplay({ name, status }: ToolRenderProps) {
  const label = TOOL_LABELS[name] || name

  return (
    <div className="flex items-center gap-2 py-1 text-xs text-gray-400">
      {status === "complete" ? (
        <CheckCircle2 size={12} className="text-emerald-400" />
      ) : (
        <Loader2 size={12} className="animate-spin text-emerald-500" />
      )}
      <span>{label}{status !== "complete" ? "..." : ""}</span>
    </div>
  )
}
